import { render, staticRenderFns } from "./StartStation.vue?vue&type=template&id=2443286a&scoped=true&"
import script from "./StartStation.vue?vue&type=script&lang=js&"
export * from "./StartStation.vue?vue&type=script&lang=js&"
import style0 from "./StartStation.vue?vue&type=style&index=0&id=2443286a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2443286a",
  null
  
)

export default component.exports